import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const currentYear = new Date().getFullYear();

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-section">
        <Link to="/" className="home-link">
            <h4 className="footerTitle">
            Repay Security <span className="footer-highlighted-text1">Services Ltd</span>
            </h4>
            <p>Committed to your Safety</p>
          </Link>
        </div>

        <div className="footer-sectionLinks">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/services/physical-security" style={{ textDecoration: 'none', color: '#fff' }}>Guarding</Link></li>
            <li><Link to="/services/security-dogs" style={{ textDecoration: 'none', color: '#fff' }}>Security Dogs</Link></li>
            <li><Link to="/services/specialized-services" style={{ textDecoration: 'none', color: '#fff' }}>Specialized Services</Link></li>
            <li><Link to="/services/electric-fence-solutions" style={{ textDecoration: 'none', color: '#fff' }}>Electric Fence Solutions</Link></li>
            <li><Link to="/services/alarm-monitoring-response" style={{ textDecoration: 'none', color: '#fff' }}>Alarm Monitoring & Response</Link></li>
            <li><Link to="/services/access-control" style={{ textDecoration: 'none', color: '#fff' }}>Access Controls</Link></li>
            <li><Link to="/services/cctv-solutions" style={{ textDecoration: 'none', color: '#fff' }}>CCTV Solutions</Link></li>
            <li><Link to="/services/bollards-turnstiles-barriers" style={{ textDecoration: 'none', color: '#fff' }}>Bollards/ Turnstiles/Barriers</Link></li>
          </ul>
        </div>

        <div className="footerContact-us-section">
          <h4>Contact Us</h4>
          <ul>
            <li>LAYCANON Nairobi, 00100 Kenya</li>
            <li>0711166611 (Daily 8am - 8pm)</li>
            <li>info@repaysecurity.co.ke</li>
          </ul>

          <div className="social-icons1">
            <a href="https://www.facebook.com/p/REPAY-SEcurity-Services-ltd-61569335214162/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
          </div>

          <div className="bottom-line" id="current-year">
            © {currentYear} Repay Security Services Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
